export const RECAPTCHA_V3_KEY = "6LeLcdcUAAAAAAayP1HyG2BwS6vwJiTw960V9Jnh";
export const RECAPTCHA_V2_KEY = "6LdMnNkUAAAAAHl2e9YbBHPI-uzSuv03rEm57EAQ";
export const RECAPTCHA_V3_KEY_CI = "6LeFW9cUAAAAAAPGO3A8gXgbLKPxT7mZCAgu9CDi";
export const RECAPTCHA_V2_KEY_CI = "6LcwhtkUAAAAABqU1ka9dQCDIwa5Ettd6Hs4ekuM";
export const recaptchaLanguages = {
    en: "en",
    it: "it",
    es: "es",
    de: "de",
    zh: "zh-CN",
    ja: "ja",
};
